// The Status Orb's registration: Home's Status Orb item. The orb is a three.js volume, not an HTML window, so
// the app opens it itself (app.js openOrb loads orb.js); nothing to register as a window.
import { registerHomeItem } from '../../core/home-items.js'

registerHomeItem({ id: 'orb', label: 'Status Orb', symbol: 'circle.hexagongrid', needs: '', section: 'toolbar', order: 80, open: (app) => app.openOrb() })
